export * from './badge.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/badge/index.ts